import React, { useEffect, useState } from 'react'
import { vote } from 'services/listicle'
import VoteButtonsUI from 'steps/shared/VoteButtonsUI'
import VoteButtonsResult from 'steps/shared/VoteButtonsResult'
import analytics from 'global/AnalyticsData'

// this polyfill should live somewhere else
Number.isInteger =
  Number.isInteger ||
  function (value) {
    return (
      typeof value === 'number' &&
      isFinite(value) &&
      Math.floor(value) === value
    )
  }

const ListicleVoteButtons = ({
  step,
  item,
  item_position,
  item_total,
  listicleId,
  itemId,
  upVotetxt,
  downVotetxt,
  upVoteIcon,
  downVoteIcon,
  selection = undefined,
  upvotes,
  downvotes,
  onVote = (itemId, selection) => {},
}) => {
  const [isVoting, setIsVoting] = useState(false)
  const [pollResults, setPollResults] = useState()

  useEffect(() => {
    // console.log("useEffect")
    // in rare cases the API might give us zeroes for both upvotes and downvotes
    if (selection && Number.isInteger(upvotes) && Number.isInteger(downvotes)) {
      setPollResults({
        upvotes: upvotes,
        downvotes: downvotes,
        selected: selection,
        totalResultsCount: upvotes + downvotes,
      })
    } else {
      setPollResults(undefined)
    }
  }, [listicleId, itemId, selection, upvotes, downvotes, setPollResults])

  // consumer clicked a vote button. Let's vote!
  const handleDispatchedVote = async (id, selection) => {
    console.log('handleDispatchedVote ' + id + ' ' + selection)

    setIsVoting(true)

    analytics.stepEvent('step_interaction_listicle_vote', step, {
      result_id: selection,
      result: selection === 'UP' ? upVotetxt : downVotetxt,
      context_id: itemId,
      context: item.subhead,
      context_total: item_total,
      context_position: item_position + 1,
    })

    vote(listicleId, id, selection)
      .then(responseData => {
        onVote(id, selection)

        // console.log(responseData)
        setPollResults({
          upvotes: responseData.detail.upvotes,
          downvotes: responseData.detail.downvotes,
          selected: selection, // would be nice if this was included in api response
          totalResultsCount:
            responseData.detail.upvotes + responseData.detail.downvotes,
        })
      })
      .catch(e => {
        console.log(e)
      })
    setIsVoting(false)
  }

  return (
    <>
      {!pollResults && (
        <VoteButtonsUI
          id={itemId}
          upVotetxt={upVotetxt}
          downVotetxt={downVotetxt}
          upVoteIcon={upVoteIcon}
          downVoteIcon={downVoteIcon}
          isVoting={isVoting}
          dispatchVote={handleDispatchedVote}
          error={false}
        />
      )}
      {pollResults && (
        <VoteButtonsResult
          selected={pollResults.selected}
          upvotes={pollResults.upvotes}
          downvotes={pollResults.downvotes}
          totalResultsCount={pollResults.totalResultsCount}
          upVotetxt={upVotetxt}
          downVotetxt={downVotetxt}
        />
      )}
    </>
  )
}

export default ListicleVoteButtons
